import { CommonModule, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../services/analytics.service';
import { OrcamentosPorDiaSemanaApi } from '../../../models/analytics.model';

@Component({
  selector: 'app-orcamentos-por-dia-semana-chart',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  templateUrl: './orcamentos-por-dia-semana-chart.component.html',
  styleUrls: ['./orcamentos-por-dia-semana-chart.component.css']
})
export class OrcamentosPorDiaSemanaChartComponent implements OnInit {
  dados: OrcamentosPorDiaSemanaApi[] = [];
  isLoading = true;
  hasError = false;

  constructor(
    private analyticsService: AnalyticsService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.carregarDados();
  }

  carregarDados(): void {
    this.isLoading = true;
    this.hasError = false;

    this.analyticsService.getMediaOrcamentosPorDiaSemana().subscribe({
      next: (data) => {
        this.dados = Array.isArray(data)
          ? [...data].sort((a, b) => (a.numDiaSemana ?? 0) - (b.numDiaSemana ?? 0))
          : [];
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.hasError = true;
        this.toastr.error('Erro ao carregar o relatório por dia da semana.');
        this.cdr.detectChanges();
      }
    });
  }

  get maiorPercentual(): number {
    return Math.max(...this.dados.map(item => Number(item.percentual ?? 0)), 0);
  }

  larguraBarra(percentual: number): number {
    const maior = this.maiorPercentual || 100;
    return Math.max(8, (Number(percentual ?? 0) / maior) * 100);
  }
}